import { Search } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/new/components/shadcn/tooltip';
import { cn } from '@/new/lib/utils';

interface SearchButtonProps {
  showSearchBar: boolean;
  onClick: () => void;
}

export const SearchButton = ({ showSearchBar, onClick }: SearchButtonProps) => {
  return (
    <TooltipProvider delayDuration={0} skipDelayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            onClick={onClick}
            className={cn(
              'group relative flex cursor-pointer items-center rounded-lg border-2 border-blue-300 bg-blue-50 px-1.5 py-1 text-blue-600 shadow-xl transition-all hover:border-blue-400 hover:bg-blue-100',
              showSearchBar && 'border-blue-400 bg-blue-400 hover:border-blue-400 hover:bg-blue-400',
            )}
          >
            <Search
              className={cn('h-4 w-4 transition-transform group-hover:scale-110', showSearchBar && 'text-white')}
            />
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{showSearchBar ? 'Close search' : 'Search in document'}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
